/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Collections_LabelInputs */

const en_common_header_explore_collections_label = /** @type {(inputs: Common_Header_Explore_Collections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const zh_common_header_explore_collections_label = /** @type {(inputs: Common_Header_Explore_Collections_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集`)
};

/**
* | output |
* | --- |
* | "Collections" |
*
* @param {Common_Header_Explore_Collections_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_collections_label = /** @type {((inputs?: Common_Header_Explore_Collections_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Collections_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_collections_label(inputs)
	return zh_common_header_explore_collections_label(inputs)
});
export { common_header_explore_collections_label as "common.header.explore.collections.label" }